module.exports = __webpack_public_path__ + "static/media/X1.1ed1779f.jpg";